/* eslint-disable */
import {Picture} from './Picture';
import {BhImage} from './BhImage';
import {ThemeSettings} from './ThemeSettings';
import {Ad} from './Ad';
/**
* @description Interface for Avensia.Commerce.Web.Models.Ads.RedAd
*/
export interface RedAd extends Ad {
	image: Picture;
	brand?: BhImage;
	campaignEnd?: Date;
	splashHeader?: string;
	splash?: string;
	themeSettings?: ThemeSettings;
}
export const isRedAd = (model: unknown): model is RedAd => (model as RedAd).component === 'Bygghemma.Commerce.Web.Models.Ads.RedAd';

